import * as React from "react";
import * as styles from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenu.css";
import { NavigationMenuItem } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItem/NavigationMenuItem";
import { GetNavigationMenuItems } from "source/app/presentation/Shared/ActivePanel/NavigationMenu/NavigationMenuItems";
import { FadeInArray } from "source/app/presentation/Shared/Animation/FadeInArray";
import { EPanelId } from "source/app/services/Shared/EPanelId";

export function NavMenuContainer({
    activePanelTitle,
}: {
    activePanelTitle: EPanelId;
}) {
    return (
        <div className={styles.container}>
            <FadeInArray
                label="navMenuItems"
                array={GetNavigationMenuItems()}
                containerClass={styles.items}
                render={(item) => (
                    <NavigationMenuItem
                        key={item.title}
                        menuItem={item}
                        activePanelTitle={activePanelTitle}
                    />
                )}
                itemDelayMs={200}
            />
        </div>
    );
}
